import { Timeline } from '@powerportalspro/react-fluent';

export function TimelineMainSample() {
  return <Timeline allowFiltering allowSavedViews savedViewsKey="timeline-main-demo" />;
}
